// lib
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import ADND from '@aytm/lib/adnd/ADND'

// components
import Popup from '@aytm/lib/rfd-ui/components/basic/popup'

import { default as ComponentContainer } from '@aytm/app/stats/page/question-views/components/Component'

// styles
import style from '@aytm/app/stats/page/question-views/components/mapping/styles/Component.module.scss'

export const DataContext = React.createContext()

const Component = ({
  Controls,
  Footer,
  children,
  model,
  data,
  states,
  prefix,
  command,
  changed,
  disabled,
  dataContextValue,
  onFeaturesChange,
  onControlsChange,
  onUpdateData,
  ...rest
}) => {
  const showMapping = useMemo(
    () =>
      (model.features == undefined || !model.features.insightsMapping) &&
      !model.disabled &&
      'function' == typeof onFeaturesChange,
    [model.features, model.disabled, onFeaturesChange]
  )

  return (
    <ComponentContainer
      Controls={Controls}
      model={model}
      data={data}
      states={states}
      changed={changed}
      disabled={disabled}
      onChange={onControlsChange}
    >
      <div className={style.component}>
        {showMapping ? (
          <div className={`${style.row} ${style['row-toggle']} p-fluid p-col-12`}>
            <div className="p-fluid p-field p-right p-col">
              <span className={style.toggle} onClick={() => onFeaturesChange('insightsMapping', true)}>
                Convert to {prefix} Mapping
              </span>
            </div>
            <div className="p-field p-right">
              <Popup
                trigger="click"
                width="500px"
                direction="bottomright"
                popupOffset={14}
                hideOtherPopupsOnShow
                content={() => (
                  <div>
                    Convert this {prefix} Lab into a {prefix} Mapping to send the data to the Insights Portal.
                  </div>
                )}
              >
                <i className="icon-aytmfd-help" />
              </Popup>
            </div>
          </div>
        ) : null}
        <DataContext.Provider value={dataContextValue}>{children}</DataContext.Provider>
      </div>
      {!disabled && (
        <Footer
          model={model}
          data={data}
          states={states}
          prefix={prefix}
          command={command}
          updateTextPrefix={states.loading ? 'Running' : 'Run'}
          onChange={onControlsChange}
          onUpdateData={onUpdateData}
          {...rest}
        />
      )}
    </ComponentContainer>
  )
}

Component.propTypes = {
  Controls: PropTypes.any,
  Footer: PropTypes.any,
  children: PropTypes.any,
  model: PropTypes.object,
  data: PropTypes.object,
  states: PropTypes.object,
  prefix: PropTypes.string,
  command: PropTypes.string,
  changed: PropTypes.bool,
  disabled: PropTypes.bool,
  dataContextValue: PropTypes.any,
  onControlsChange: PropTypes.func,
  onUpdateData: PropTypes.func,
  onFetchApiKey: PropTypes.func,
  onPublish: PropTypes.func,
  onPublished: PropTypes.func,
  onFeaturesChange: PropTypes.func
}

Component.displayName = 'Component'

export default Component

ADND().connect()
